import React from 'react';
import { Toast } from 'react-bootstrap';

const Notification = (props) => {
  const notification = props.notification || {};
  const setNotification = props.setNotification;
  const defaultIcon = (
    <img 
      className='mr-2 '
      src='/c2_color_icon.svg' 
      style={{ width: '25px', height: '25px' }}
    />
  );

  const icon = notification.icon ? notification.icon : defaultIcon;

  return (
    <div
      style={{
        position: 'absolute',
        bottom: '25px',
        right: '25px',
        zIndex: 100,
      }}
    >
      <Toast
        show={notification}
        onClose={() => setNotification(null)}
        animation={true}
        delay={30000}
        autohide
      >
        <Toast.Header className='text-uppercase'>
          <span className='flex-grow-1 text-left'>{ icon } <b>{ notification.header }</b></span>
        </Toast.Header>
        <Toast.Body>{ notification.body }</Toast.Body>
      </Toast>
    </div>
  );
}

export default Notification;